var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubwayCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.75,148.71A3.26,3.26,0,0,0,50,152H164.8a3.25,3.25,0,0,0,3.25-3.25V74.15c0-1.25.23-14.51-8.5-23-5.21-5.07-12.37-7.34-21.32-6.76H72.64C65.19,44,50.37,48.87,46.8,69.79a3.53,3.53,0,0,0,0,.56ZM168,106.7c-57.83,21.41-120.78-1.36-121.41-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.72,138.22a6.35,6.35,0,1,0-6.36-6.35A6.35,6.35,0,0,0,69.72,138.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,138.22a6.35,6.35,0,1,0-6.35-6.35A6.35,6.35,0,0,0,145.48,138.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.04,
    y1: 152.81,
    x2: 41.63,
    y2: 180.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.87,
    y1: 152.81,
    x2: 172.28,
    y2: 180.17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubwayCar);
export default __webpack_public_path__ + "static/media/SUBWAY_CAR.b88089f142ed23a9c9acb7ee6cfa4c3f.svg";
export { ForwardRef as ReactComponent };